

import {useHead} from '@vueuse/head'
import {pageTitle} from '../../state/sidebarLayoutState'
import SidebarLayout from '../../layouts/SidebarLayout.vue'
import {computed, defineComponent, onMounted, reactive, ref} from "vue";
import {mapGetters, mapState} from "vuex";
import store, {State, ActionTypes} from '../../store'

export interface OSellBuyData {
  sellbuy: string;
  mid: string;
  sbchar: string;
  score: string,
}

export interface OStrategiesData {
  strategy: string;
  midval: string;
  sbarray: OSellBuyData[];
}

export interface OData {
  username: string;
  strategies: OStrategiesData[];
}

export default defineComponent({
  name: 'OrdersList',
  components: {
    SidebarLayout,
  },

  setup() {
    pageTitle.value = 'JB Drax Honoré Dashboard'
    useHead({
      // Can be static or computed
      title: computed(() => pageTitle.value),
    })

    let orderData: OData[] = reactive([]);

    const getOrderData = () => {
      orderData = [
        {
          username: 'MT05',
          strategies: [
            {
              strategy: 'CT2TUH2CT2TUH2',
              midval: '4.12',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '99',
                  sbchar: '@',
                  score: '4.120',
                },
                {
                  sellbuy: 'Buy',
                  mid: '35',
                  sbchar: '@',
                  score: '4.107',
                },
                {
                  sellbuy: 'Buy',
                  mid: '100',
                  sbchar: '@',
                  score: '4.105',
                },
                {
                  sellbuy: 'Buy',
                  mid: '100',
                  sbchar: '@',
                  score: '4.103',
                }
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
            {
              strategy: 'CT2FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            }
          ]
        },
        {
          username: 'MORR',
          strategies: [
            {
              strategy: '7s10s',
              midval: '5.44',
              sbarray: [
                {
                  sellbuy: 'Buy',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
                {
                  sellbuy: 'Buy',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
              ]
            },
          ]
        },
        {
          username: 'BENTLEY',
          strategies: [
            {
              strategy: '7s10s',
              midval: '5.44',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
                {
                  sellbuy: 'Sell',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
                {
                  sellbuy: 'Sell',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
                {
                  sellbuy: 'Sell',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
                {
                  sellbuy: 'Buy',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
              ]
            },
            {
              strategy: '7s10s',
              midval: '5.44',
              sbarray: [
                {
                  sellbuy: 'Buy',
                  mid: '53mm',
                  sbchar: '@',
                  score: '5.15',
                },
              ]
            },
          ]
        },
        {
          username: 'AVT8',
          strategies: [
            {
              strategy: 'CT2TUH2CT2TUH2',
              midval: '4.12',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '99',
                  sbchar: '@',
                  score: '4.120',
                },
                {
                  sellbuy: 'Buy',
                  mid: '35',
                  sbchar: '@',
                  score: '4.107',
                },
                {
                  sellbuy: 'Buy',
                  mid: '100',
                  sbchar: '@',
                  score: '4.105',
                },
                {
                  sellbuy: 'Buy',
                  mid: '100',
                  sbchar: '@',
                  score: '4.103',
                }
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
            {
              strategy: 'CT5FVH2',
              midval: '-9.015',
              sbarray: [
                {
                  sellbuy: 'Sell',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.995',
                },
                {
                  sellbuy: 'Buy',
                  mid: '50',
                  sbchar: '@',
                  score: '-8.999',
                },
              ]
            },
          ]
        },
      ];

      return orderData;
    };

    const getSbClass = (sellbuy: string) => {
      return sellbuy === 'Sell' ? 'has-background-danger' : 'has-background-info'
    }

    return {
      getOrderData,
      getSbClass
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters([
      'isStaff'
    ])
  },

})
